/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { eventNameExcluded } from "../../../globals/constants";
import { ITrapReceive } from "../../../store/api/admin/types";
import { IEventConfig } from "../../../store/api/deviceConfig/types";
// import { titleCase } from "../../../utils/helpers";

export const preparForTableData = (data: IEventConfig[]) => {
  let newData: IEventConfig[] = [];
  if (data.length > 0) {
    data.forEach((item: IEventConfig) => {
      if (!eventNameExcluded.includes(item.key)) {
        if (item.key === "eranNotifTransceiverFault") {
          item = { ...item, displayName: "Transceiver Fault" };
        }
        newData.push(item);
      }
    });
  }
  return newData;
};

export const normalizeTrapProtocol = (type: "auth" | "priv", protoType?: string) => {
  const value = (protoType || "").trim().toUpperCase();

  const authMap: Record<string, string> = {
    NONE: "NO_AUTH",
    NO_AUTH: "NO_AUTH",
    MD5: "MD5_AUTH",
    MD5_AUTH: "MD5_AUTH",
    SHA: "SHA_AUTH",
    SHA_AUTH: "SHA_AUTH",
  };

  const privMap: Record<string, string> = {
    NONE: "NO_PRIV",
    NO_PRIV: "NO_PRIV",
    DES: "DES_PRIV",
    DES_PRIV: "DES_PRIV",
    "AES-128": "AES_128_PRIV",
    AES_128: "AES_128_PRIV",
    AES_128_PRIV: "AES_128_PRIV",
  };

  if (type === "auth") {
    return authMap[value] || "NO_AUTH";
  }

  return privMap[value] || "NO_PRIV";
};

// Backward-compatible wrapper for existing callers.
export const checkProtocol = (type: string, protoType: any) => {
  return type === "isAuth"
    ? normalizeTrapProtocol("auth", protoType)
    : normalizeTrapProtocol("priv", protoType);
};

export const handleTrapDataUnchecked = (name: string, trapReceiveData: ITrapReceive, trapReceiveDetails: any) => {
  if (name === "snmpv1v2") {
    return {
      ...trapReceiveData,
      community: "",
    };
  } else if (name === "snmpv3") {
    return {
      ...trapReceiveData,
      engineId: "",
      userName: "",
      authPassword: "",
      privacyPassword: "",
      authProtocol: "NO_AUTH",
      privProtocol: "NO_PRIV"
    };
  }
};

export const handleTrapDataChecked = (name: string, trapReceiveData: ITrapReceive, trapReceiveDetails: any) => {
  if (name === "snmpv1v2") {
    return {
      ...trapReceiveData,
      community: trapReceiveDetails?.community || "",
    };
  } else if (name === "snmpv3") {
    return {
      ...trapReceiveData,
      engineId: trapReceiveDetails?.engineId || "",
      userName: trapReceiveDetails?.userName || "",
      authPassword: trapReceiveDetails?.authPassword || "",
      privacyPassword: trapReceiveDetails?.privacyPassword || "",
      authProtocol: normalizeTrapProtocol("auth", trapReceiveDetails?.authProtocol),
      privProtocol: normalizeTrapProtocol("priv", trapReceiveDetails?.privProtocol),
    };
  }
};
